module.exports = __webpack_public_path__ + "img/login-wexin.920c9cee.png";